export const roundToMinute = (date: Date): Date => {
    const next = new Date(date)
    next.setSeconds(0, 0)
    return next
}

export const formatForDateTimeInput = (date: Date): string => {
    if (Number.isNaN(date.getTime())) return ''
    const pad = (value: number) => String(value).padStart(2, '0')
    return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}T${pad(date.getHours())}:${pad(
        date.getMinutes()
    )}`
}

export const parseDateTimeInput = (value: string): Date | null => {
    if (!value) return null
    const parsed = new Date(value)
    return Number.isNaN(parsed.getTime()) ? null : parsed
}

export const parseRawExecuteAt = (raw: string): Date | null => {
    const v = raw.trim()
    if (!v) return null
    if (/^\d+$/.test(v)) {
        const ms = Number(v)
        if (!Number.isFinite(ms)) return null
        const parsed = new Date(ms)
        return Number.isNaN(parsed.getTime()) ? null : parsed
    }
    const parsed = new Date(v)
    return Number.isNaN(parsed.getTime()) ? null : parsed
}

export const formatDateTimeForTable = (iso: string | null): string => {
    if (!iso) return '—'
    const parsed = new Date(iso)
    if (Number.isNaN(parsed.getTime())) return '—'
    return new Intl.DateTimeFormat('en-GB', { dateStyle: 'medium', timeStyle: 'short' }).format(parsed)
}


export const addDaysISO = (days: number): string => {
  const now = new Date()
  const target = new Date(now.getTime() + days * 24 * 60 * 60 * 1000)
  return target.toISOString()
}
